"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cacheUpdateMatrix = void 0;
var _queryKeyHelpers = require("./queryKeyHelpers");
/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

// TODO: Complete cache invalidation https://gus.lightning.force.com/lightning/_classic/%2Fa07EE00001NoYplYAF
const cacheUpdateMatrix = exports.cacheUpdateMatrix = {
  createShopperContext(customerId, {
    parameters
  }) {
    return {
      invalidate: [{
        queryKey: _queryKeyHelpers.getShopperContext.queryKey(parameters)
      }]
    };
  },
  updateShopperContext(_customerId, {
    parameters
  }) {
    return {
      update: [{
        queryKey: _queryKeyHelpers.getShopperContext.queryKey(parameters)
      }]
    };
  },
  deleteShopperContext(_customerId, {
    parameters
  }) {
    return {
      remove: [{
        queryKey: _queryKeyHelpers.getShopperContext.queryKey(parameters)
      }]
    };
  }
};